module.exports = __webpack_public_path__ + "static/img/dyzy.26f944b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/dyzy.png
// module id = v0no
// module chunks = 0